import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function SmsOptInDisclosure() {
  return (
    <>
      <Helmet>
        <title>SMS Opt-In Disclosure - TEJ Solutions Hub</title>
        <meta name="description" content="SMS opt-in disclosure for TEJ Solutions Hub messaging services. Learn how consent is collected and messages are sent." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800' }}>SMS Opt-In Disclosure</h1>
          <p style={{ fontSize: '1.1rem', opacity: '0.95' }}>TEJ Solutions Hub Messaging Services</p>
        </div>

        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '4rem 2rem' }}>
          <div style={{ background: '#fef3c7', padding: '2rem', borderRadius: '12px', marginBottom: '3rem', border: '2px solid #fbbf24' }}>
            <p style={{ fontSize: '1.1rem', color: '#92400e', fontWeight: '600', marginBottom: '1rem' }}>
              About Our SMS Communications:
            </p>
            <p style={{ color: '#78350f', lineHeight: '1.8', marginBottom: '1rem' }}>
              TEJ SUSTAINABILITY GROUP, INC. (d/b/a TEJ Solutions Hub) uses Twilio to send SMS and email communications to our customers and clients about our software development and digital marketing services.
            </p>
            <p style={{ color: '#78350f', lineHeight: '1.8', marginBottom: '0', fontWeight: '600' }}>
              Note: We obtain proper consent before sending SMS or marketing emails. Contact information collected on tejsolutionshub.com is used for business consultation, customer communications, and financing referral inquiries with your consent.
            </p>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              About Our SMS Services
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              TEJ Solutions Hub uses SMS and email to communicate with our customers about our software development, digital marketing, and business financing referral services. We may send:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', paddingLeft: '2rem', marginBottom: '1rem' }}>
              <li>Project updates and consultations</li>
              <li>Service information and announcements</li>
              <li>Appointment reminders and meeting notifications</li>
              <li>Account and billing information</li>
              <li>Marketing messages about our services (with consent)</li>
              <li>Technical support and customer service</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              How SMS Consent is Collected
            </h2>
            
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', color: '#1f2937', marginBottom: '1rem' }}>
              How We Collect Consent:
            </h3>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              When you provide your contact information on our website or through our services, you will see consent language similar to:
            </p>
            <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', border: '2px solid #e5e7eb', marginBottom: '1rem' }}>
              <p style={{ fontSize: '0.95rem', color: '#4b5563', lineHeight: '1.6', fontStyle: 'italic' }}>
                "By checking this box and providing your contact information, you agree to receive communications from TEJ Solutions Hub via phone, email, or SMS regarding our services. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe or HELP for help. Consent is not required to use our services."
              </p>
            </div>
            <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginTop: '1rem' }}>
              <strong>Important:</strong> We obtain express consent before sending SMS or marketing emails. You can opt out at any time.
            </p>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Who Sends These Messages
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              Messages are sent directly by <strong>TEJ Solutions Hub</strong> to communicate with our customers and clients about our software development, digital marketing, and business financing referral services.
            </p>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              We use Twilio as our messaging platform to deliver SMS and email communications.
            </p>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Types of Messages You May Receive
            </h2>
            <p style={{ fontSize: '1.05rem', color: '#6b7280', marginBottom: '1.5rem' }}>
              Depending on your consent preferences, you may receive:
            </p>
            
            <div style={{ display: 'grid', gap: '1rem' }}>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Service Information</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Information about our software development and digital marketing services
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Project Updates</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Updates about your projects, consultations, and deliverables
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Account Messages</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Account information, billing, and administrative communications
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #7c3aed' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>Marketing Messages</h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6', marginBottom: '0' }}>
                  Promotional offers and updates about our services (with consent)
                </p>
              </div>
            </div>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Message Frequency and Costs
            </h2>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li><strong>Frequency:</strong> Message frequency varies. We may send occasional updates or more frequent project communications.</li>
              <li><strong>Data Rates:</strong> Message and data rates may apply based on your mobile carrier plan.</li>
              <li><strong>Carrier Charges:</strong> Standard messaging rates from your carrier apply.</li>
              <li><strong>No Purchase Required:</strong> Consent to receive messages is not required to use our services.</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              How to Opt-Out (Unsubscribe)
            </h2>
            <div style={{ background: '#d1fae5', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem', border: '2px solid #10b981' }}>
              <p style={{ fontSize: '1.05rem', color: '#065f46', lineHeight: '1.8', marginBottom: '0.5rem' }}>
                <strong>To Stop Receiving Messages:</strong>
              </p>
              <p style={{ fontSize: '1.05rem', color: '#065f46', lineHeight: '1.8', marginBottom: '0' }}>
                Reply <strong>STOP</strong>, <strong>UNSUBSCRIBE</strong>, <strong>CANCEL</strong>, <strong>END</strong>, or <strong>QUIT</strong> to any message
              </p>
            </div>
            <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem', border: '2px solid #3b82f6' }}>
              <p style={{ fontSize: '1.05rem', color: '#1e40af', lineHeight: '1.8', marginBottom: '0.5rem' }}>
                <strong>For Help:</strong>
              </p>
              <p style={{ fontSize: '1.05rem', color: '#1e40af', lineHeight: '1.8', marginBottom: '0' }}>
                Reply <strong>HELP</strong> or email <strong>contact@tejsolutionshub.com</strong>
              </p>
            </div>
            <p style={{ fontSize: '1rem', color: '#6b7280', lineHeight: '1.8' }}>
              Opt-out requests are processed immediately, though it may take up to 24 hours for changes to take full effect. After opting out, you will no longer receive messages unless you opt in again.
            </p>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Compliance and Regulations
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              All SMS and email communications from TEJ Solutions Hub comply with:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem', marginBottom: '1rem' }}>
              <li><strong>TCPA (Telephone Consumer Protection Act):</strong> Federal law regulating telemarketing and SMS</li>
              <li><strong>CTIA Guidelines:</strong> Cellular industry messaging best practices</li>
              <li><strong>A2P 10DLC:</strong> Application-to-Person messaging standards</li>
              <li><strong>Carrier Policies:</strong> Requirements from mobile carriers (AT&T, Verizon, T-Mobile, etc.)</li>
            </ul>
          </div>

          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              Privacy and Data Protection
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: '#4b5563', marginBottom: '1rem' }}>
              Your phone number and message data are handled according to our <Link to="/privacy-policy" style={{ color: '#7c3aed', fontWeight: '600' }}>Privacy Policy</Link>. We:
            </p>
            <ul style={{ fontSize: '1.05rem', lineHeight: '2', color: '#4b5563', paddingLeft: '2rem' }}>
              <li>Do not sell or share your phone number with third parties</li>
              <li>Use encryption to protect data transmission</li>
              <li>Maintain opt-out lists to honor your preferences</li>
              <li>Comply with data protection regulations</li>
              <li>Retain message logs only as required by regulations</li>
            </ul>
          </div>

          <div style={{ background: '#fef3c7', padding: '2rem', borderRadius: '12px', border: '2px solid #fbbf24', marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem' }}>
              Messaging Platform Notice
            </h3>
            <p style={{ fontSize: '1rem', color: '#78350f', lineHeight: '1.8', marginBottom: '0' }}>
              TEJ Solutions Hub uses Twilio as our messaging platform to send SMS and email communications to our customers. We obtain proper consent and maintain compliance with all applicable regulations.
            </p>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/sms-compliance-consent" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              marginRight: '1rem'
            }}>
              View Compliance Policy
            </Link>
            <Link to="/privacy-policy" style={{
              display: 'inline-block',
              background: 'white',
              color: '#7c3aed',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid #7c3aed'
            }}>
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
